import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconNook24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconNook24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M20.329 16.123a.25.25 0 0 1 .111.208v1.4l-7.72-4.156V4.738l1.22.762a.25.25 0 0 1 .117.212v2.403c0 .636.345 1.221.9 1.53l2.163 1.202a.25.25 0 0 1 .128.218v2.068c0 .585.293 1.132.78 1.456zm-9.109-2.548L3.5 17.732v-1.4a.25.25 0 0 1 .111-.209l2.301-1.534a1.75 1.75 0 0 0 .78-1.456v-2.068a.25.25 0 0 1 .128-.218l2.163-1.202c.556-.309.9-.894.9-1.53V5.712a.25.25 0 0 1 .118-.212l1.219-.762zm-6.907 5.423 7.658-4.123 7.656 4.123-1.532.85a.25.25 0 0 1-.233.006l-1.943-.972a1.75 1.75 0 0 0-1.493-.034l-2.354 1.047a.25.25 0 0 1-.203 0l-2.355-1.046a1.75 1.75 0 0 0-1.493.033l-1.943.972a.25.25 0 0 1-.233-.005zm17.225.654-2.714 1.508a1.75 1.75 0 0 1-1.633.036l-1.943-.972a.25.25 0 0 0-.213-.005l-2.354 1.046a1.75 1.75 0 0 1-1.422 0L8.905 20.22a.25.25 0 0 0-.213.005l-1.943.972a1.75 1.75 0 0 1-1.633-.036l-2.73-1.517L2 19.43v-3.1c0-.585.292-1.131.78-1.456l2.3-1.534a.25.25 0 0 0 .112-.208v-2.068c0-.635.344-1.221.9-1.53l2.163-1.201a.25.25 0 0 0 .128-.219V5.712c0-.604.31-1.164.823-1.484l2.367-1.48.397-.248.397.248 2.367 1.48c.512.32.823.88.823 1.484v2.403c0 .091.05.175.128.219l2.163 1.201c.556.309.9.895.9 1.53v2.068a.25.25 0 0 0 .112.208l2.3 1.534c.488.325.78.871.78 1.456v3.098l-.368.204z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconNook24);
